import { GET, POST, PUT } from '../request'

export const getEvaluacionesAlumno = ({ alumno, mes }) =>
  GET('/api/profes/alumnos/evaluacion-alumnos/list/alumno', { alumno, mes })

export const getAlumnosAEvaluar = ({ fecha }) =>
  GET('/api/profes/alumnos/evaluacion-alumnos/list/day', { fecha })

export const createEvaluacion = ({
  alumnoId,
  fecha,
  actitud,
  limpieza,
  asignaturas,
  observaciones
}) =>
  POST(
    '/api/profes/alumnos/evaluacion-alumnos/evaluate',
    {},
    { alumnoId, fecha, actitud, limpieza, asignaturas, observaciones }
  )

export const updateEvaluacion = ({
  id,
  actitud,
  limpieza,
  asignaturas,
  observaciones
}) =>
  PUT(
    '/api/profes/alumnos/evaluacion-alumnos/evaluate',
    {},
    { id, actitud, limpieza, asignaturas, observaciones }
  )
